<template>
    <el-menu mode="horizontal" text-color="#fff" class="nav-bar" :default-active="activeIndex">
        <!-- 首页：index 改为 "/home"，与路由路径对应 -->
        <el-menu-item index="/home" @click="handleMenuJump('/home')">首页</el-menu-item>
        <!-- 下载：index 改为 "/official"，与路由路径对应 -->
        <el-menu-item index="/official" @click="handleMenuJump('/official')">电脑版</el-menu-item>
        <!-- 网页版：index 改为 "/mobile"，与路由路径对应 -->
        <!-- <el-menu-item index="/mobile" @click="handleMenuJump('/mobile')">网页版</el-menu-item> -->
        <el-menu-item index="external-ark" @click="handleMenuJump('https://arkpro.cn/')">网页版</el-menu-item>
        <!-- API对接：index 改为 "/api"，与路由路径对应 -->
        <el-menu-item index="/api" @click="handleMenuJump('/api')">API对接</el-menu-item>
        <!-- 关于我们：index 改为 "/about"，与路由路径对应 -->
        <el-menu-item index="/about" @click="handleMenuJump('/about')">关于我们</el-menu-item>
    </el-menu>
</template>

<script setup>
// 新增：导入所需依赖（useRoute 获取当前路由，onMounted 初始化，watch 监听路由变化）
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { ElMenu, ElMenuItem } from 'element-plus';

// 初始化路由实例（跳转用）和当前路由实例（获取路径用）
const router = useRouter();
const route = useRoute();

// 新增：定义激活状态变量，用于绑定 el-menu 的 default-active
const activeIndex = ref('');

// 初始化：组件挂载时，将当前路由路径赋值给 activeIndex，实现默认高亮
onMounted(() => {
    activeIndex.value = route.path;
});

// 新增：监听路由变化，同步更新 activeIndex，实现路由切换后菜单高亮同步
watch(
    () => route.path, // 监听当前路由的 path 变化
    (newPath) => {
        activeIndex.value = newPath;
    },
    { immediate: true } // 立即执行一次，确保初始化生效
);

// 原有导航跳转逻辑（保持不变）
const handleMenuJump = (path) => {
    if (path.startsWith('/')) {
        const hasRoute = (routes, targetPath) => {
            for (const route of routes) {
                if (route.path === targetPath) return true;
                if (route.children && hasRoute(route.children, targetPath)) return true;
            }
            return false;
        };

        const allRoutes = router.getRoutes();
        if (hasRoute(allRoutes, path)) {
            try {
                router.push(path);
            } catch (error) {
                ElMessage.warning("该页面暂未上线");
            }
        } else {
            ElMessage.warning("该页面暂未上线");
        }
    } else if (path.startsWith('http')) {
        window.open(path, '_blank', 'noopener noreferrer');
    }
};
</script>

<style scoped>
/* 导航栏样式 - 完整保留原有效样式，确保显示效果一致 */
.nav-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 0 20px;
    background: none;

    /* background-color: "#000"; */
    /* text-color: "#fff";
    active-text-color: "#409EFF"; */
    .el-menu-item {
        color: #fff;

    }
}



/* 可选：自定义高亮菜单的背景色（如需） */
::v-deep .el-menu-item.is-active {
    background-color: rgba(64, 158, 255, 0.2) !important;
}
</style>